module.exports = __webpack_public_path__ + "static/media/logo@2x.7f3b4d60.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo@2x.png
// module id = 15
// module chunks = 0